import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import { DialogProps } from "@saleor/types";
import { OrderLineStatusEnum } from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";

import { OrderLineUpdateQuantity_storeOrderLineUpdateQuantity_storeOrder_lines } from "../../types/OrderLineUpdateQuantity";
export interface StoreOrderEditDialogProps extends DialogProps {
  productIds: any;
  onSubmitRemoveProduct: any;
  onSubmitOrderLineStatus: (lineIds: any, status: OrderLineStatusEnum) => void;
  onSubmitOrderLineUpdateQty: (
    lines: OrderLineUpdateQuantity_storeOrderLineUpdateQuantity_storeOrder_lines[]
  ) => void;
}

const useStyles = makeStyles(
  () => ({
    backBtn: {
      "&:hover": {
        backgroundColor: "#E5E5E5"
      },
      backgroundColor: "#ffffff",
      border: "1px solid #E5E5E5"
    },
    buttonActions: {
      display: "flex",
      width: "100%"
    },
    buttonWidth: {
      margin: "3px",
      width: "100%"
    }
  }),
  { name: "StoreOrderAddProduct" }
);

const StoreOrderEditDialog: React.FC<StoreOrderEditDialogProps> = props => {
  const {
    onClose,
    open,
    productIds,
    onSubmitRemoveProduct,
    onSubmitOrderLineStatus,
    onSubmitOrderLineUpdateQty
  } = props;
  const classes = useStyles(props);

  const handleRemoveSubmit = () => {
    onSubmitRemoveProduct(productIds.payload);
    onClose();
  };

  const handleOutOfStockSubmit = () => {
    onSubmitOrderLineStatus(
      productIds.payload,
      OrderLineStatusEnum.OUT_OF_STOCK
    );
    onClose();
  };

  const handleUpdateQtySubmit = () => {
    onSubmitOrderLineUpdateQty(productIds.payload);
    onClose();
  };

  const checkAction = () => {
    switch (productIds.type) {
      case "REMOVE_PRODUCT":
        return (
          <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
            <>
              <DialogTitle>Confirm</DialogTitle>
              <DialogContent>
                Are you sure you want to remove the selected product from the
                order?
              </DialogContent>
              <DialogActions>
                <div className={classes.buttonActions}>
                  <Button
                    onClick={onClose}
                    variant="contained"
                    color="default"
                    className={classNames(classes.buttonWidth, classes.backBtn)}
                  >
                    BACK
                  </Button>
                  <Button
                    autoFocus
                    onClick={handleRemoveSubmit}
                    variant="contained"
                    color="primary"
                    className={classes.buttonWidth}
                  >
                    CONFIRM
                  </Button>
                </div>
              </DialogActions>
            </>
          </Dialog>
        );
      case "OUT_OF_STOCK":
        return (
          <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
            <>
              <DialogTitle>Confirm</DialogTitle>
              <DialogContent>
                Are you sure you want to make the selected products as Out Of
                Stock?
              </DialogContent>
              <DialogActions>
                <div className={classes.buttonActions}>
                  <Button
                    onClick={onClose}
                    variant="contained"
                    color="default"
                    className={classNames(classes.buttonWidth, classes.backBtn)}
                  >
                    BACK
                  </Button>
                  <Button
                    autoFocus
                    onClick={handleOutOfStockSubmit}
                    variant="contained"
                    color="primary"
                    className={classes.buttonWidth}
                  >
                    CONFIRM
                  </Button>
                </div>
              </DialogActions>
            </>
          </Dialog>
        );
      case "UPDATE_QTY":
        return (
          <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
            <>
              <DialogTitle>Confirm</DialogTitle>
              <DialogContent>
                Are you sure you want to save the changes in the order?
              </DialogContent>
              <DialogActions>
                <div className={classes.buttonActions}>
                  <Button
                    onClick={onClose}
                    variant="contained"
                    color="default"
                    className={classNames(classes.buttonWidth, classes.backBtn)}
                  >
                    BACK
                  </Button>
                  <Button
                    autoFocus
                    onClick={handleUpdateQtySubmit}
                    variant="contained"
                    color="primary"
                    className={classes.buttonWidth}
                  >
                    CONFIRM
                  </Button>
                </div>
              </DialogActions>
            </>
          </Dialog>
        );
      default:
        return null;
    }
  };
  return checkAction();
};
StoreOrderEditDialog.displayName = "StoreOrderEditDialog";
export default StoreOrderEditDialog;
